import { IBaseEntity } from "./base-entity"
import { IFile } from './file'
import { IMainComponent } from './main-component'

export enum FoulingType {
  None = 0,
  AlgaeSlime = 1,
  BlueMussels = 2,
  TubeWorms = 3,
  Barnacles = 4,
  Kelp = 5,
}

export enum FoulingAmount {
  None = 0,
  Low = 1,
  Normal = 2,
  High = 3,
}

export interface WashingReportDto extends IBaseEntity {
  mainComponentId: number
  foulingType: FoulingType
  foulingAmount: FoulingAmount
  pressure: number
  timeConsumption: number
  notes?: string
  inspection: boolean
  extraTimeConsumption: boolean
  mainComponent?: IMainComponent
  washedOn: string
  fileIds: number[]
  washingReportAttachments?: WashingReportAttachment[]
}

export interface WashingReportAttachment {
  id: number
  washingReportId: number
  washingReport: string | null
  fileId: number
  file: IFile
}
